import React from 'react';
import { Header, Nav } from 'components';
import './TabletPageLayout.scss';

interface TabletPageLayoutProps {
  children: React.ReactNode;
}

function TabletPageLayout({ children }: TabletPageLayoutProps) {
  return (
    <div className="tablet-layout">
      <div className="tablet-layout-header">
        <Header />
      </div>
      <div className="tablet-layout-nav">
        <Nav />
      </div>
      <div className="tablet-layout-content">{children}</div>
    </div>
  );
}

export default TabletPageLayout;
